import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '@app/services/auth.service';
import { catchError, map } from "rxjs/operators";
import { BusinessUnitsService } from "@app/services/accounts/business-units.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    constructor(private authService: AuthService,
                private router: Router,
                private businessUnitsService: BusinessUnitsService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.handle();
    }

    canLoad(
        route: Route,
        segments: UrlSegment[]
      ): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isLoggedIn()) {
          return this.businessUnitsService.onPageLoad().pipe(
            map(() => true),
            catchError(() => {
              // clearAuthLocally(), not logout(): logout() returns a cold Observable, so calling
              // it here without subscribing never cleared the stored auth. The stale `auth` key
              // then kept isLoggedIn() true, and GuestGuard bounced /login back to /admin ->
              // /admin/dashboard -> here, looping forever
              this.authService.clearAuthLocally();
              this.router.navigate(['/login']);
              return of(false);
            })
          );
        }

        this.router.navigate(['/login']);
        return false;
      }

    private handle(): Observable<boolean | UrlTree> | boolean | UrlTree {
        if (this.authService.isLoggedIn()) {
            return this.businessUnitsService.onPageLoad().pipe(
                map(() => true),
                catchError(() => {
                    // See canLoad() — must clear synchronously, or the redirect below lands on
                    // /login while still "logged in" and GuestGuard sends us straight back here.
                    this.authService.clearAuthLocally();
                    return of(this.router.parseUrl('/login'));
                })
            );
        }

        return this.router.parseUrl('/login');
    }
}
